export default class ButtonSimple extends Phaser.Button {
  constructor({
    game,
    x = 0,
    y = 0,
    up,
    over,
    atlas = 'ui_buttons',
    playClick = true,
    sfxID = 'generic_ui',
  }) {
    super(game, x, y, atlas);
    this.setFrames(over, up, up, up);
    this.anchor.set(0.5);

    this.playClick = playClick;
    this.sfxID = sfxID;
    this.data = {};
    this.out = up;
    this.over = over;
    this.isOver = false;
    this.input.useHandCursor = true;

    this.onInputDown.add(this.onDown, this);
    this.onInputUp.add(this.onUp, this);
    this.onInputOver.add(this.onOver, this);
    this.onInputOut.add(this.onOut, this);

    this.init();
  }

  init() {
    if (this.game) {
      const mx = this.game.input.activePointer.x;
      const my = this.game.input.activePointer.y;
      if (this.isWithinBounds(mx, my)) {
        // this.onOver();
      } else {
        // this.onOut();
      }
    }
    this.enable();
  }

  enable() {
    this.input.enabled = true;
  }

  disable() {
    this.input.enabled = false;
    // this.alpha = 0.5;
  }

  isWithinBounds(x, y) {
    return this.getBounds().contains(x, y);
  }

  onOver() {
    this.isOver = true;
  }

  onOut() {
    this.isOver = false;
  }

  onDown() {
    this.playClick && this.game.sounds.playSFX(this.sfxID, { spriteID: 'sfx' });
  }

  onUp() {}

  destroy(destroyChildren = true) {
    this.clearFrames();
    this.disable();
    this.onInputDown.removeAll();
    this.onInputDown = null;
    this.onInputUp.removeAll();
    this.onInputUp = null;
    this.onInputOver.removeAll();
    this.onInputOver = null;
    this.onInputOut.removeAll();
    this.onInputOut = null;
    super.destroy(destroyChildren);
  }
}
